
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.004 22.65a.877.877 0 001.426.274l.521-.521a.877.877 0 01.62-.257h7.674c.857 0 1.686-.303 2.341-.855l5.716-4.816a1.86 1.86 0 00.692-1.6 1.725 1.725 0 00-.966-1.376 1.863 1.863 0 00-1.738.106l-6.832 3.928a1.753 1.753 0 01-.874.234h-2.89a.495.495 0 110-.99h1.834a.845.845 0 00.846-.824l.013-.499a1.568 1.568 0 00-1.57-1.61H3.905a.77.77 0 00-.546.225L.257 17.172a.878.878 0 00-.186.965l1.933 4.512zM20.438 1.48A1.482 1.482 0 0018.958 0H2.046a1.482 1.482 0 00-1.48 1.48v2.537h19.872V1.48zM2.046 12.261h16.912a1.481 1.481 0 001.48-1.48V5.709H.566v5.074a1.481 1.481 0 001.48 1.48zm13.107-4.228h.845a.634.634 0 010 1.269h-.845a.634.634 0 110-1.269zm-3.383 0h.846a.634.634 0 110 1.269h-.846a.634.634 0 110-1.269zm-3.382 0h.845a.634.634 0 110 1.269h-.845a.634.634 0 010-1.269zm-3.383 0h.846a.634.634 0 010 1.269h-.846a.634.634 0 110-1.269z","fill":"#737791"}})])
          )
        }
      }
    